import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';

export const jwtTokenGuard: CanActivateFn = (route, state) => {
  /*const router = inject(Router);*/
  const authService = inject(AuthService);
  if (authService.token$()) {
    return true;
  }
  authService.logout(true);

  return false;
};
